module.exports = __webpack_public_path__ + "static/media/designPatent_30-0988593.d76499be.png";